import { fromJS } from 'immutable';
import * as _ from 'lodash';
import * as actions from '@modules/appeals/actions/workCase';
import { fetchingState } from '@constants';
import { SUCCESS, START, ERROR } from '@modules/appraisal/actions/global';

const initialState = {
  appealPanels: {
    data: [],
    state: null,
  },
  panelStatistics: {
    data: {},
    state: null,
  },
  directAssignments: {
    data: [],
    state: null,
  },
  agentDocketGroups: {
    data: [],
    state: null,
  },
  selectedPanelViewPanel: {
    panelID: null,
    data: {},
    nextAppealCase: {},
    loaded: false,
  },
};

export default (state = fromJS(initialState), action) => {
  switch (action.type) {
    case actions.FETCH_APPEAL_PANELS[START]: {
      return state.setIn(['appealPanels', 'state'], fetchingState.FETCHING);
    }
    case actions.FETCH_APPEAL_PANELS[SUCCESS]: {
      return state
        .setIn(['appealPanels', 'state'], fetchingState.LOADED)
        .setIn(
          ['appealPanels', 'data'],
          fromJS(_.get(action, 'data.results', [])),
        );
    }
    case actions.FETCH_APPEAL_PANELS[ERROR]: {
      return state.setIn(['appealPanels', 'state'], fetchingState.ERROR);
    }
    case actions.FETCH_DIRECT_ASSIGNMENTS[START]: {
      return state.setIn(
        ['directAssignments', 'state'],
        fetchingState.FETCHING,
      );
    }
    case actions.FETCH_DIRECT_ASSIGNMENTS[SUCCESS]: {
      return state
        .setIn(['directAssignments', 'state'], fetchingState.LOADED)
        .setIn(
          ['directAssignments', 'data'],
          fromJS(_.get(action, 'data.results', [])),
        );
    }
    case actions.FETCH_DIRECT_ASSIGNMENTS[ERROR]: {
      return state.setIn(['directAssignments', 'state'], fetchingState.ERROR);
    }
    case actions.GET_DAILY_STATISTICS_FOR_PANEL[START]: {
      return state.setIn(['panelStatistics', 'state'], fetchingState.FETCHING);
    }
    case actions.GET_DAILY_STATISTICS_FOR_PANEL[SUCCESS]: {
      return state
        .setIn(['panelStatistics', 'state'], fetchingState.LOADED)
        .setIn(
          ['panelStatistics', 'data'],
          fromJS(_.get(action, 'data.results[0]', {})),
        );
    }
    case actions.GET_DAILY_STATISTICS_FOR_PANEL[ERROR]: {
      return state.setIn(['panelStatistics', 'state'], fetchingState.ERROR);
    }
    case actions.SET_PANEL_VIEW_PANEL: {
      return state
        .setIn(
          ['selectedPanelViewPanel', 'panelID'],
          action.payload ? action.payload.panelID : null,
        )
        .setIn(
          ['selectedPanelViewPanel', 'data'],
          action.payload ? action.payload : null,
        )
        .setIn(['selectedPanelViewPanel', 'nextAppealCase'], {})
        .setIn(
          ['selectedPanelViewPanel', 'loaded'],
          action.payload ? true : false,
        );
    }
    case actions.CLEAR_PANEL_VIEW_PANEL: {
      return state
        .setIn(['selectedPanelViewPanel', 'panelID'], null)
        .setIn(['selectedPanelViewPanel', 'data'], {})
        .setIn(['selectedPanelViewPanel', 'nextAppealCase'], {})
        .setIn(['selectedPanelViewPanel', 'loaded'], false);
    }
    case actions.SET_PANEL_VIEW_PANEL_NEXT_APPEAL: {
      return state.setIn(
        ['selectedPanelViewPanel', 'nextAppealCase'],
        action.payload ? action.payload : {},
      );
    }
    default:
      return state;
  }
};
